// components
import GridPageAbstract from '../../GridPageAbstract';
import { DiscountCircleBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class CurrencyExchangeRatesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'currencyExchangeRates';
        this.Server =
            this.props.context.getState().server.currencyExchangeRates;

        this.headerStartIcon = DiscountCircleBulkIcon;
        this.bannerImage = config?.bannerImages?.wallets || '';

        this.searchFields = ['currencyExchangePair.fromCurrency.name', 'currencyExchangePair.toCurrency.name'];

        this.hiddenColumns = config?.hiddenColumns?.currencyExchangeRates || [];

        this.Head = [
            {
                id: 'currencyExchangePair',
                label: 'currencyExchangePair',
                alignRight: false,
                cell: 'FromTo',
                fromObj: 'fromCurrency',
                toObj: 'toCurrency',
                display: 'range',
                disableEditor: true,
                filterBy: 'currencyExchangePairs',
                filterCell: 'Context'
            },
            { id: 'rate', label: 'rate', alignRight: false, cell: 'Text' },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
